import React from 'react';
import Sidebar from './Sidebar';
import styles from './MainLayout.module.css';
import { User } from '../../types';

interface MainLayoutProps {
  children: React.ReactNode;
  user?: User | null;
  onLogout: () => void;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children, user, onLogout }) => {
  return (
    <div className={styles.appLayout}>
      <Sidebar user={user} onLogout={onLogout} />
      <main className={styles.mainContent}>{children}</main>
    </div>
  );
};

export default MainLayout;
